import { render, staticRenderFns } from "./company-report.vue?vue&type=template&id=4635dabf&scoped=true&"
import script from "./company-report.vue?vue&type=script&lang=js&"
export * from "./company-report.vue?vue&type=script&lang=js&"
import style0 from "./company-report.vue?vue&type=style&index=0&id=4635dabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635dabf",
  null
  
)

export default component.exports